import { ChartType, Plugin } from "chart.js";

import { greyCol } from "../colors";

export function createYearSeparatorPlugin<T extends ChartType>(): Plugin<T> {
  return {
    id: "yearSeparator",
    afterDraw(chart) {
      const xScale = chart.scales.x;
      const yScale = chart.scales.y;
      const ctx = chart.ctx;
      const labels = chart.data.labels as string[];

      if (!labels || labels.length < 2) return;

      for (let i = 1; i < labels.length; i++) {
        const prevLabel = labels[i - 1];
        const currLabel = labels[i];

        const prevYearPart = prevLabel.split(" ")[1]; // "2024"
        const currYearPart = currLabel.split(" ")[1]; // "2025"

        if (!prevYearPart || !currYearPart || prevYearPart === currYearPart)
          continue;

        const prevX = xScale.getPixelForValue(i - 1);
        const currX = xScale.getPixelForValue(i);

        const midX = (prevX + currX) / 2;

        ctx.save();
        ctx.beginPath();
        ctx.setLineDash([4, 4]);
        ctx.strokeStyle = greyCol;
        ctx.lineWidth = 1;
        ctx.moveTo(midX, yScale.top);
        ctx.lineTo(midX, yScale.bottom + 140);
        ctx.stroke();
        ctx.restore();
      }
    },
  };
}
